/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *==================================================
 */

// Standard Libraries
import React from "react";
import TableSortLabel from "@material-ui/core/TableSortLabel/TableSortLabel";
import { useTranslation } from "react-i18next";

// Custom Libraries
import { Th } from "../components";
import { TableColumnDef } from "../constants/table";

export interface TableHeaderProps {
  key: any;
  tableColumn: TableColumnDef;
  sortable: boolean;
  sortOrder: string;
  orderBy: string;
  sortAction: Function;
}

const TableHeader: React.FC<TableHeaderProps> = (props: any) => {
  const { key, tableColumn, sortable, sortOrder, sortAction, orderBy } = props;
  const { t } = useTranslation();

  return (
    <>
      <Th key={key}>
        {sortable ? (
          <TableSortLabel
            active={orderBy === tableColumn.keyLookup.key}
            direction={sortOrder}
            onClick={() => {
              sortAction(tableColumn.keyLookup.key);
            }}>
            {t(tableColumn.title)}
          </TableSortLabel>
        ) : (
          <>{t(tableColumn.title)}</>
        )}
      </Th>
    </>
  );
};

export default TableHeader;
